import styled from "styled-components"

const HiddenComponent = styled.div`
  display: none;
    visibility: hidden;
    `
const BlankLabelComponent = ({ children }) => <div>{children}</div>
const InteractiveBlock = ({ children, ...props }) => {
  return (
    <button
      style={{
        textDecoration: "none",
        background: 'transparent',
        border: "none",
        outline: "none"        
      }}
      {...props}
    >
      {children}
    </button>
  )
}

export {
  HiddenComponent,
  BlankLabelComponent,
  InteractiveBlock
}

